<template>
    <b-input-group-append v-bind="$props">
        <slot />
    </b-input-group-append>
</template>

<script>
import { BInputGroupAppend } from 'bootstrap-vue'

export default {
    components: { BInputGroupAppend },
}
</script>